export default __webpack_public_path__ + "static/milestones_app-f0054ce5dd06cdbfed048e1950f4ac66.jpeg";